// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../css/variables.css\"","BASE_COLOR":"#1673FF"};